import { PAGE_SIZE } from '../const';
import { page } from './page';

interface Config {
  index: number;
  size?: number;
}

// index 가 36n+25 수열의 원소일 경우 광고 구좌 (2n + 1 번째 페이지 7번 구좌)
export const isProductCardAdBannerSlot = ({ index, size = PAGE_SIZE }: Config) =>
  page({ index, size }) % 2 === 1 && index % size === 7;
